<template>
  <div class="contents">
    <top></top>
    <div class="overview">
      <div class="overview-l">
        <div class="overview-l-t">
          <div class="overview-title">资源用量</div>
          <div class="overview-content">
            <div class="overview-item">
              <div class="overview-tl">团队席位</div>
              <div class="overview-num">
                <span class="overview-num-l">{{ detail.useSeats || 0 }}</span
                ><span class="overview-num-c"> / </span><span class="overview-num-r">{{ detail.buySeats }}</span>
              </div>
              <div class="overview-sub">已用量/总量</div>
              <div class="overview-btn">
                <el-button v-hasPermi="['customer:seat:renew']" type="primary" @click="hanldeSeat" size="small" plain
                  >购买席位</el-button
                >
              </div>
            </div>
            <!-- <div class="overview-item">
              <div class="overview-tl">余额</div>
              <div class="overview-num">
                <span
                  style="color: #666666; font-size: 18px; margin-right: 10px"
                  >$</span
                >
                <span class="overview-num-l">{{ detail.balance }} </span>
              </div>
              <div class="overview-sub">总余额</div>
              <div class="overview-btn">
                <el-button
                  type="primary"
                  @click="handleTopUp"
                  size="small"
                  plain
                  >立即充值</el-button
                >
              </div>
            </div> -->
            <!-- <div class="overview-item">
              <div class="overview-tl">应用站点</div>
              <div class="overview-num">
                <span class="overview-num-l">1</span
                ><span class="overview-num-c"> / </span
                ><span class="overview-num-r">1</span>
              </div>
              <div class="overview-sub">已用量/总量</div>
            </div> -->
          </div>
          <div class="overview-title" style="padding-top: 20px">扩展服务</div>
          <div class="overview-bottom">
            <div class="overview-b-item">
              <div class="overview-b-tl">翻译包</div>
              <div class="overview-b-b">
                <div class="overview-b-t">
                  <span class="overview-b-t-num">{{ formatCount(translateNum.count) }}</span>
                  <span class="overview-b-t-text">可用(字符)</span>
                </div>
                <div class="overview-b-t">
                  <span class="overview-b-t-num">{{ formatCount(translateNum.sumCount) }}</span>
                  <span class="overview-b-t-text">总量(字符)</span>
                </div>
                <div class="overview-b-btn">
                  <el-button @click="buyTranslate" type="primary" size="small" plain>购买翻译包</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overview-r">
        <div class="overview-r-card">
          <div class="overview-r-card-t">
            <div class="overview-r-card-t-icon">
              <img v-if="detail.isMember" src="../../assets/image/Subtract.png" alt="" />
              <img v-else src="../../assets/image/free.png" alt="" />
            </div>
            <div class="overview-r-card-t-text">
              <span class="overview-r-card-t-text-title">{{ detail.packageName || "免费版" }}</span>
              <span class="overview-r-card-t-text-text"
                >到期时间：{{ detail.isMember ? formatTime(detail.expireTime) : "--" }}</span
              >
            </div>
          </div>
          <div class="overview-r-card-b">
            <div class="overview-r-card-b-text">
              <img class="overview-r-card-b-text-img" src="../../assets/image/gou.png" alt="" />
              <span class="overview-r-card-b-text-text">创建项目</span>
            </div>
            <div class="overview-r-card-b-text">
              <img class="overview-r-card-b-text-img" src="../../assets/image/gou.png" alt="" />
              <span class="overview-r-card-b-text-text">收件箱</span>
            </div>
            <div class="overview-r-card-b-text" v-if="detail.isMember">
              <img class="overview-r-card-b-text-img" src="../../assets/image/gou.png" alt="" />
              <span class="overview-r-card-b-text-text">智能Ai</span>
            </div>
            <div class="overview-r-card-b-text" v-if="detail.isMember">
              <img class="overview-r-card-b-text-img" src="../../assets/image/gou.png" alt="" />
              <span class="overview-r-card-b-text-text">专属客服</span>
            </div>
          </div>
          <div class="overview-r-card-btn">
            <el-button v-if="detail.isMember" class="overview-r-card-btn-btn" type="primary" @click="handleOpen"
              >续费</el-button
            >
            <el-button v-else class="overview-r-card-btn-btn" type="primary" @click="handleOpen">开通</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买席位 -->
    <el-dialog title="增加席位" :visible.sync="dialogVisible" width="30%">
      <div class="dialog-form">
        <div class="form-item">
          <div class="label">订阅席位</div>
          <div class="content">
            <el-input-number v-model="form.seats" :min="1" :max="100000" :step="1" step-strictly></el-input-number>
          </div>
        </div>
        <div class="form-item">
          <div class="label">订阅周期</div>
          <div class="content">{{ detail.days }} 天</div>
        </div>
        <div class="form-item">
          <div class="label">到期日期</div>
          <div class="content">{{ formatTime(detail.expireTime) || "--" }}</div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <img style="width: 20px; height: 20px; margin-right: 10px" src="../../assets/image/shuzi.png" alt="" />
            <span>数字货币USDT</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">选择网络</div>
          <div class="content">
            <el-select v-model="coinId" @change="handleChange" placeholder="请选择">
              <el-option v-for="item in coinList" :key="item.chain_id" :label="item.title" :value="item.chain_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <div class="label">合计</div>
          <div class="content num">$ {{ keepTwoDecimalsNoRound(accmount) }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn" @click="handleBuySeat">支付订单</el-button>
      </div>
    </el-dialog>

    <!-- 购买翻译包 -->
    <el-dialog title="购买翻译包" :visible.sync="dialogVisible4" width="30%">
      <div class="dialog-form">
        <div class="form-item">
          <div class="label">
            <span>翻译包</span>
            <span class="tip">${{ detail.translatePrice || 0 }}/百万字符</span>
          </div>
          <div class="content">
            <el-select v-model="translateCount" placeholder="请选择">
              <el-option
                v-for="item in translateOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <img style="width: 20px; height: 20px; margin-right: 10px" src="../../assets/image/shuzi.png" alt="" />
            <span>数字货币USDT</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">选择网络</div>
          <div class="content">
            <el-select v-model="coinId" @change="handleChange" placeholder="请选择">
              <el-option v-for="item in coinList" :key="item.chain_id" :label="item.title" :value="item.chain_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <div class="label">合计</div>
          <div class="content num">$ {{ keepTwoDecimalsNoRound(accmount2) }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn" @click="handleBuyTranslate">支付订单</el-button>
      </div>
    </el-dialog>

    <el-dialog title="待支付" @opened="handleOpenDia" @closed="handleClose" :visible.sync="dialogVisible3" width="30%">
      <div class="dialog-form">
        <div class="form-item" style="justify-content: center">
          <div class="form-accmount">
            <div class="accmount-tl">支付金额</div>
            <div class="accmount-num">$ {{ rowData.amount }}</div>
            <div class="accmount-text">
              剩余支付时间 <span class="accmount-text-date">{{ timeText }}</span>
            </div>
          </div>
        </div>
        <div class="form-item" style="justify-content: center">
          <div class="content" style="width: 50%">
            <img style="width: 100%" :src="rowData.qrCode" alt="" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">收款地址</div>
          <div class="content">{{ rowData.address || "--" }}</div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <span>{{ rowData.paymentMethod || "--" }}</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">订单编号</div>
          <div class="content">
            <span>{{ rowData.cid || "--" }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn" @click="dialogVisible3 = false">已支付</el-button>
      </div>
    </el-dialog>

    <!-- 充值 -->
    <!-- <el-dialog title="立即充值" :visible.sync="dialogVisible2" width="30%">
      <div class="dialog-form">
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <img
              style="width: 20px; height: 20px; margin-right: 10px"
              src="../../assets/image/shuzi.png"
              alt=""
            />
            <span>数字货币USDT</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">选择网络</div>
          <div class="content">
            <el-select
              v-model="coinId"
              @change="handleChange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in coinList"
                :key="item.chain_id"
                :label="item.title"
                :value="item.chain_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-item">
          <div class="label">地址</div>
          <div class="content">{{ address || "--" }}</div>
        </div>
        <div class="form-item">
          <div class="label">余额</div>
          <div class="content">
            <span class="num">$ {{ detail.balance }}</span>
          </div>
        </div>
        <div class="form-item" style="justify-content: center">
          <div class="content" style="width: 80%">
            <img style="width: 100%" :src="qrCodeUrl" alt="" />
          </div>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { formatTime } from "../../utils/index";
import top from "./components/top.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      coinId: "",
      address: "",
      qrCodeUrl: "",
      form: {
        seats: "",
      },
      translateCount: "1",
      translateOptions: [],
      rowData: {},
      newPackage: {},
      coinList: [],
      now: Date.now(),
      timer: null,
      translateNum: {},
    };
  },
  mounted() {
    this.$store.dispatch("loadPackageInfo");
    this.getCoinList();
    this.getData("customer_translate");
    this.getTranslateBalance();
  },
  watch: {
    timeText(newValue, oldValue) {
      if (newValue == "00:00:00") {
        this.$message({
          type: "warning",
          message: "订单已过期",
        });
        setTimeout(() => {
          this.dialogVisible3 = false;
        }, 1000);
      }
    },
  },
  computed: {
    timeText() {
      const end = new Date(this.rowData.expirationTime).getTime();
      let diff = end - this.now;

      if (diff <= 0) {
        return "00:00:00";
      }

      const totalSeconds = Math.floor(diff / 1000);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return (
        String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
      );
    },
    accmount() {
      const seat =
        Number(this.form.seats || 0) * Number(this.detail.days || 0) * Number(this.detail.seatPrice / 30 || 0);
      return seat;
    },
    accmount2() {
      const translate = Number(this.translateCount || 0) * Number(this.detail.translatePrice || 0);
      return translate;
    },
    detail() {
      return this.$store.state.userStore.packageInfo;
    },
  },
  components: {
    top,
  },
  methods: {
    formatTime,
    getData(key) {
      this.$http({
        url: `/customer/getTranslateDict/${key}`,
        method: "get",
      }).then((res) => {
        this.translateOptions = res.data;
      });
    },
    formatCount(val) {
      const num = Number(val || 0);
      if (num < 10000) {
        return String(num);
      }
      const value = (num / 10000).toFixed(1);
      return value.endsWith(".0") ? parseInt(value) + "万" : value + "万";
    },
    getTranslateBalance() {
      this.$http({
        url: `/customer/translateBalance`,
        method: "get",
      }).then((res) => {
        this.translateNum = res;
      });
    },
    buyTranslate() {
      if (!this.detail.isMember) {
        this.$notify({
          title: "提示",
          message: "请先订阅服务后再购买翻译包",
          type: "warning",
        });
        return;
      }
      this.coinId = this.coinList[0].chain_id;
      this.getAddress(this.coinId);
      this.dialogVisible4 = true;
    },
    keepTwoDecimalsNoRound(val) {
      const num = Number(val);
      if (!Number.isFinite(num)) return "0.00";
      const factor = 100;
      const truncated = num >= 0 ? Math.floor(num * factor) : Math.ceil(num * factor);
      return (truncated / factor).toFixed(2);
    },
    handleOpenDia() {
      this.now = Date.now();
      this.timer = setInterval(() => {
        this.now = Date.now();
      }, 1000);
    },
    handleClose() {
      this.rowData = {};
      this.timer && clearInterval(this.timer);
    },
    handleTopUp() {
      this.coinId = this.coinList[0].chain_id;
      this.getAddress(this.coinId);
      this.dialogVisible2 = true;
    },
    hanldeSeat() {
      if (!this.detail.isMember) {
        this.$notify({
          title: "提示",
          message: "请先订阅服务后再购买席位",
          type: "warning",
        });
        return;
      }
      this.form.seats = 1;
      this.coinId = this.coinList[0].chain_id;
      this.getAddress(this.coinId);
      this.dialogVisible = true;
    },
    handleBuyTranslate() {
      this.$confirm("你确认要购买翻译包, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "/customer/translateRenew",
          method: "POST",
          data: {
            packageId: this.newPackage.id,
            translateCount: this.translateCount,
            paymentMethod: this.coinId,
            address: this.address,
            qrCode: this.qrCodeUrl,
            type: "4",
          },
        }).then((res) => {
          this.$store.dispatch("loadPackageInfo");
          this.rowData = JSON.parse(res.packageJson);
          Object.assign(this.rowData, { amount: res.amount, expirationTime: res.expirationTime, cid: res.cid });
          this.dialogVisible4 = false;
          setTimeout(() => {
            this.dialogVisible3 = true;
          }, 500);
        });
      });
    },
    handleBuySeat() {
      this.$confirm("你确认要增加席位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "/customer/package/seatRenew",
          method: "POST",
          data: {
            packageId: this.newPackage.id,
            seats: this.form.seats,
            paymentMethod: this.coinId,
            address: this.address,
            qrCode: this.qrCodeUrl,
            type: "3",
          },
        }).then((res) => {
          this.$store.dispatch("loadPackageInfo");
          this.rowData = JSON.parse(res.packageJson);
          Object.assign(this.rowData, { amount: res.amount, expirationTime: res.expirationTime, cid: res.cid });
          this.dialogVisible = false;
          setTimeout(() => {
            this.dialogVisible3 = true;
          }, 500);
        });
      });
    },
    getCoinList() {
      this.$http({
        url: "/customer/getCoinList",
        method: "get",
      }).then((res) => {
        this.coinList = res.address_coins.filter((item) => item.title === "USDT-ERC20" || item.title === "USDT-TRC20");
      });
    },
    handleChange(val) {
      // console.log(val);
      this.getAddress(val);
    },
    getAddress(val) {
      this.$http({
        url: "/customer/getAddress",
        method: "POST",
        data: {
          chain_id: val,
        },
      }).then((res) => {
        this.address = res.address;
        this.qrCodeUrl = res.qrCodeUrl;
      });
    },
    handleOpen() {
      this.$router.push({
        path: "/home/setting/subscribe",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.overview {
  display: flex;
  justify-content: space-between;
  .overview-l {
    flex: 1;
    border-right: 1px solid #e6e6e6;
    .overview-l-t {
      padding: 20px;
      .overview-title {
        text-align: left;
        font-size: 15px;
        font-weight: 500;
      }
      .overview-content {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .overview-item {
          padding: 20px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          cursor: default;
          width: 26%;
          border-radius: 10px;
          border: 1px solid #e5e5e5;
          overflow: hidden;
          .overview-tl {
            font-size: 13px;
            font-weight: 500;
            color: #333333;
          }
          .overview-num {
            padding-top: 15px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            .overview-num-c {
              font-size: 24px;
              color: #666666;
            }
            .overview-num-r {
              color: #666666;
            }
          }
          .overview-sub {
            font-size: 12px;
            color: #999999;
            padding: 3px 0 15px;
          }
        }
        .overview-item:hover {
          border: 1px solid #1777ff;
        }
      }
      .overview-bottom {
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        .overview-b-item {
          display: flex;
          flex-direction: column;
          border: 1px solid #e6e6e6;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 20px;
          cursor: default;
          .overview-b-tl {
            font-weight: 500;
            font-size: 13px;
            color: #666666;
            text-align: left;
          }
          .overview-b-b {
            display: flex;
            justify-content: space-between;
            .overview-b-t {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              margin-top: 15px;
              .overview-b-t-num {
                font-size: 26px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 5px;
                font-family: DINAlternate-Bold;
              }
              .overview-b-t-text {
                font-size: 12px;
                color: #666666;
              }
            }
            .overview-b-btn {
              margin-top: 15px;
            }
          }
        }
        .overview-b-item:hover {
          border: 1px solid #1777ff;
        }
      }
    }
  }

  .overview-r {
    width: 330px;
    padding: 20px;
    .overview-r-card {
      height: 500px;
      display: flex;
      flex-direction: column;
      border: 1px solid #1777ff;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      .overview-r-card-t {
        display: flex;
        padding: 20px;
        background: #f4f8fe;
        .overview-r-card-t-icon {
          width: 90px;
          height: 90px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .overview-r-card-t-text {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: flex-start;
          .overview-r-card-t-text-title {
            font-size: 20px;
            font-weight: bold;
          }
          .overview-r-card-t-text-text {
            font-size: 12px;
            color: #666666;
            margin-top: 10px;
          }
        }
      }
      .overview-r-card-b {
        display: flex;
        flex-direction: column;
        padding: 20px;
        .overview-r-card-b-text {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .overview-r-card-b-text-img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
          .overview-r-card-b-text-text {
            font-size: 14px;
          }
        }
      }
      .overview-r-card-btn {
        width: 90%;
        height: 40px;
        padding: 20px 0;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 0);
        .overview-r-card-btn-btn {
          width: 100%;
        }
      }
    }
  }
}

.dialog-form {
  display: flex;
  flex-direction: column;
  .form-item {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .tip {
        font-size: 12px;
        color: #999999;
      }
    }
    .content {
      display: flex;
      align-items: center;
    }
    .form-accmount {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: default;
      .accmount-num {
        color: #333;
        font-weight: bold;
        font-size: 30px;
        padding: 10px 0;
      }
      .accmount-text-date {
        font-weight: bold;
        font-size: 18px;
        color: #d35846;
      }
    }
  }
}
.num {
  font-weight: bold;
  color: #333333;
  font-size: 18px;
}
.error {
  color: red;
  margin-left: 10px;
  font-size: 13px;
}
.order-btn {
  width: 100%;
}
</style>
